import { IkasThemeJsonColor } from "./color";
import { IkasThemeJsonFavicon } from "./favicon";
import { IkasThemeJsonFontFamily } from "./font-family";

export type IkasThemeJsonSettings = {
  colors: IkasThemeJsonColor[];
  favicon: IkasThemeJsonFavicon;
  stockPreference: IkasThemeJsonStockPreference;
  fontFamily: IkasThemeJsonFontFamily;
};

export enum IkasThemeJsonStockPreference {
  HIDE_OUT_OF_STOCK = "HIDE_OUT_OF_STOCK",
  SHOW_ALL = "SHOW_ALL",
  SHOW_OUT_OF_STOCK_AT_END = "SHOW_OUT_OF_STOCK_AT_END",
}
